import { render } from "./AboutScreen.vue?vue&type=template&id=99f167ce&scoped=true"
import script from "./AboutScreen.vue?vue&type=script&lang=js"
export * from "./AboutScreen.vue?vue&type=script&lang=js"

import "./AboutScreen.vue?vue&type=style&index=0&id=99f167ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f167ce"]])

export default __exports__